// extracted by mini-css-extract-plugin
module.exports = {"sort-wrapper":"sorting_sort-wrapper__iTj2f","sort-title":"sorting_sort-title__LUO3N","items_amount":"sorting_items_amount__nN39M","sort_container":"sorting_sort_container__p62lP"};